import { render, staticRenderFns } from "./rightMain.vue?vue&type=template&id=65e7f837&scoped=true&"
import script from "./rightMain.vue?vue&type=script&lang=js&"
export * from "./rightMain.vue?vue&type=script&lang=js&"
import style0 from "./rightMain.vue?vue&type=style&index=0&id=65e7f837&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7f837",
  null
  
)

export default component.exports